import Cookies from 'js-cookie';
export default {
  setCookie: function (name, value, expire) {
    console.log(expire);
    if (expire) {
      // window.document.cookie =
      //   name +
      //   '=' +
      //   escape(value) +
      //   ';path=/;max-age=' +
      //   expire +
      //   ';domain=' +
      //   GetCookieDomain();
      Cookies.set(name, value, {
        expires: expire,
        path: '/',
        domain: GetCookieDomain(),
      });
    } else {
      // window.document.cookie =
      //   name +
      //   '=' +
      //   escape(value) +
      //   ';domain=' +
      //   GetCookieDomain() +
      //   ';path=/;';
      Cookies.set(name, value, {
        path: '/',
        domain: GetCookieDomain(),
      });
    }
  },
  getCookie: function (name) {
    // let matchResult = unescape(window.document.cookie).match(
    //   '(^|;) ?' + name + '=([^;]*)(;|$)'
    // );
    // return matchResult ? matchResult[2] : null;
    return Cookies.get(name);
  },
  deleteCookie: function (name) {
    // this.setCookie(name, '', 0);
    Cookies.remove(name, { domain: GetCookieDomain() });
    Cookies.remove(name); // TODO 之后所有cookie统一了 可以去掉
  },
  logout(cb) {
    this.deleteCookie('newSupplierCookie');
    this.deleteCookie('buyerCookie');
    this.deleteCookie('accessToken');
    this.deleteCookie('fsellerId');
    this.deleteCookie('constantInfo');

    if (cb) {
      cb();
    }
  },
  // 在提交或者取消时存这个标识
  setFlagStorage(key, val) {
    window.localStorage.setItem(key, val);
  },
  // 在列表页获取这个标识
  getFlagStorage(key) {
    return window.localStorage.getItem(key);
  },
  // 清掉点击取消或者提交时候的标识
  removeFlagStorage(key) {
    window.localStorage.removeItem(key);
  },
  // 清除pageFlagChange标识
  removePageChangeFlag(key) {
    window.localStorage.removeItem(key);
  },
  selectAll() {
    let selectAllEle = document.getElementById('selectAll');
    let checkboxs = document.getElementsByClassName('checkbox-item');
    let state = selectAllEle.checked;
    let len = checkboxs.length;
    for (let i = 0; i < len; i++) {
      checkboxs[i].checked = state;
    }
  },
  // 取消全选
  cancelSelectAll() {
    let selectAllEle = document.getElementById('selectAll');
    let checkboxs = document.getElementsByClassName('checkbox-item');
    let len = checkboxs.length;
    for (let i = 0; i < len; i++) {
      checkboxs[i].checked = false;
    }
    selectAllEle.checked = false;
  },
  changeSelectStatus() {
    let selectAllEle = document.getElementById('selectAll');
    let checkboxs = document.getElementsByClassName('checkbox-item');
    let len = checkboxs.length;
    let checkedArr = [];
    for (let i = 0; i < len; i++) {
      if (checkboxs[i].checked) {
        checkedArr.push(checkboxs[i]);
      }
    }
    if (checkedArr.length == len) {
      selectAllEle.checked = true;
    } else {
      selectAllEle.checked = false;
    }
  },
};
function GetCookieDomain() {
  var host = location.hostname;
  var ip = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  if (ip.test(host) === true || host === 'localhost') return host;
  var regex = /([^]*).*/;
  var match = host.match(regex);
  if (typeof match !== 'undefined' && null !== match) host = match[1];
  if (typeof host !== 'undefined' && null !== host) {
    var strAry = host.split('.');
    // if (strAry.length > 1) {
    //   host = strAry[strAry.length - 2] + '.' + strAry[strAry.length - 1];
    // }
    host = strAry.join('.');
  }
  return '.' + host;
}
